// We use axios to handle our XHR's
import axios from 'axios';

// Vue app instance
import app from './app';

// We use qs to parse querystrings
import qs from 'qs';

import { debounce } from './utilities';

// Setup defaults for parameter serialization
axios.defaults.paramsSerializer = function (params) {
  return qs.stringify(params, { arrayFormat: 'brackets', encode: false });
}

axios.defaults.baseURL = Laravel.portalUrl;

/**
 * Register an HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */
axios.interceptors.request.use(
  (config) => {
    config.headers['X-CSRF-TOKEN'] = Laravel.csrfToken;
    config.headers['Authorization'] = 'Bearer ' + portal.jwtToken;

    return config;
  }, 

  (error) => {
    return Promise.reject(error);
  }
);

let toast = debounce(() => {
  app.$toast.add({ 
    type: 'danger', 
    text: 'Your session expired. Login here!', 
    duration: 8000, 
    action: () => { window.location.replace(Laravel.portalUrl) } 
  })
}, 2000, true);

/**
 * Register a response interceptor to handle errors
 */
axios.interceptors.response.use(
  response => { return response }, 

  ({ response: error }) => {
    if (!error) error = {
      data: {
        error_type: 'NO_DATA'
      }
    };

    switch (error.data.error_type) {
      case 'JWT':
        if (Laravel.user) return toast();
      break;

      case 'NO_DATA':
        console.log('No response data in request');
      break;
    }

    return Promise.reject(error);
  }
);

export default axios;


// WEBPACK FOOTER //
// ./resources/assets/js/app/axios.config.js